/**
 * MultiplexAd — one Google AdSense Multiplex ("related content" grid) unit
 * at the end of a guide article, before the FAQ.
 *
 * Renders nothing unless Admin > Settings has ads on AND a Multiplex slot
 * ID set (useAdSettings). Used only on TopicalGuidePage and
 * RegionalItineraryPage, once per page (docs/GOOGLE_ADS_SETUP.md). No
 * heading of our own: AdSense draws its own, and our text next to ads could
 * read as an ad label/endorsement.
 *
 * Shares the wrapper, "Advertisement" label, push() guard and unfilled
 * collapse with InArticleAd (AdUnit.jsx). A filled unit also gets a subtle
 * top divider (.ad-slot--multiplex in index.css).
 *
 * `gap` = vertical space around a filled unit (CSS length, default 3.5rem).
 */
import { useLocation } from 'react-router-dom';
import useAdSettings from '@/hooks/useAdSettings';
import AdUnit from './AdUnit';

const MULTIPLEX_INS = {
  style: { display: 'block' },
  'data-ad-format': 'autorelaxed',
};

const MultiplexAd = ({ gap = '3.5rem' }) => {
  const { multiplexEnabled, client, multiplexSlot } = useAdSettings();
  const { pathname } = useLocation();
  if (!multiplexEnabled) return null;
  // Keyed by route so SPA navigation mounts a fresh <ins> (one push each).
  return (
    <AdUnit
      key={`${pathname}#multiplex`}
      client={client}
      slot={multiplexSlot}
      position="multiplex"
      gap={gap}
      testId="multiplex-ad"
      className="ad-slot--multiplex"
      insProps={MULTIPLEX_INS}
    />
  );
};

export default MultiplexAd;
